import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "text-h6" }

import { computed, ref, watch } from "vue";

import { container } from "@/system/container";
import { TOKENS } from "@/system/tokens";

import ColorInput from "@/modules/tag/components/ColorInput.vue";
import TagView from "@/modules/tag/components/Tag.vue";
import { TagExists } from "../model/TagAPI";
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useItemStore } from "@/modules/item/model/ItemService";


export default /*#__PURE__*/_defineComponent({
  __name: 'TagDialog',
  props: ["valueModel", 'tag'],
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }) {

const props = __props;


const $q = useQuasar()

const tagService = container.get(TOKENS.tagService)
const tag = ref()
let original: string



const errorMessage = ref("");

const showDialog = computed({
  get() {
    return props.valueModel
  },
  set(value) {
    emits("update:modelValue", value)
  }
})

watch(props, () => {
  tag.value  = props.tag
  if (!original) 
    original = JSON.stringify(tag.value)
})


const saveTag = async () => {
  var message = ''
  var type = 'positive'

  try {
    if (tag.value.id) { 
      await tagService.update(tag.value)
      message = 'Tag updated!'
    } else {
      await tagService.create(tag.value)
      message = 'Tag created!'
    }
    showDialog.value = false
  } catch (e) {
    message =  e.message
    type = 'negative'
  }
  $q.notify({message: message, type: type})
}

const deleteTag = async () => {
  const itemStore = useItemStore()
  var message = ''
  var type = 'positive'
  if (itemStore.itemsWithTag(tag.value).length > 0) {
      message = `Could not delete. Tag is in use.`
      type = 'negative'
  } else {
    try {
      await tagService.deleteTag(tag.value)
      showDialog.value = false
      message = `Tag delete.`
    } catch (e) {
      message = `Could not delete Tag.`
      type = 'negative'
    }
  }

  $q.notify({message: message, type: type})
}


const closeDialog = async () => {
  const originalTag = JSON.parse(original)
  if (originalTag.id) 
    tagService.resetTag(originalTag)
  showDialog.value = false;
};


return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      (tag.value)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            style: {"width":"100%","max-width":"35rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(tag.value.id ? "Update Tag" : "New Tag"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: tag.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tag.value.title) = $event)),
                    type: "text",
                    label: "Title",
                    hint: "Enter a title"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, {
                    modelValue: tag.value.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tag.value.description) = $event)),
                    label: "Description",
                    autogrow: "",
                    type: "textarea",
                    counter: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (tag.value.title)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TagView, { tag: tag.value }, null, 8, ["tag"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(ColorInput, {
                    label: "Select border color",
                    modelValue: tag.value.style.border,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tag.value.style.border) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(ColorInput, {
                    label: "Select background color",
                    modelValue: tag.value.style.background,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tag.value.style.background) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(ColorInput, {
                    label: "Select text color",
                    modelValue: tag.value.style.color,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tag.value.style.color) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (errorMessage.value)
                ? (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_card_actions, { align: "between" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    rounded: "",
                    label: "Cancel",
                    color: "$grey-5",
                    onClick: closeDialog
                  }, null, 512), [
                    [_directive_close_popup]
                  ]),
                  (tag.value.id)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        flat: "",
                        rounded: "",
                        label: "Delete",
                        color: "negative",
                        onClick: deleteTag
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    rounded: "",
                    label: "Save",
                    color: "positive",
                    onClick: saveTag
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})